<template>
  <div class="columns is-multiline mt-20">
    <div class="column is-12">
      <div class="level">
        <div class="level-left">
          <p class="has-text-weight-bold is-size-14-px has-text-grid-1">
            {{$t('creerClient.labelContact')}}
          </p>
        </div>
        <div class="level-right">
          <b-button type="is-primary" @click="ajoutContactActive = true">
            <p class="is-size-14px has-text-weight-bold">
              {{$t('creerClient.btnAjoutContact')}}
            </p>
          </b-button>
        </div>
      </div>
    </div>
    <div class="column is-12" v-for="(contact, i) in getContacts" :key="i">
      <div
        class="card-contact">
        <div class="media media-align-center">
          <figure class="media-left">
            <p class="image">
              <img class="picto-file-mail contact" src="@/assets/images/general/default_img.png">
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <div class="columns is-12 is-vcentered">
                <div class="column is-6">
                  <p class="is-size-14px has-text-weight-bold has-text-gird-1 mb-0">
                    {{contact.prenom}} {{contact.nom}}
                  </p>
                  <p class="is-size-7 has-text-default">
                    {{contact.fonction}}
                  </p>
                </div>
                <div class="column is-6">
                  <p class="is-size-7 has-text-default mb-0">
                    {{contact.email}}
                  </p>
                  <p class="is-size-7 has-text-default">
                    {{contact.telephone}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="media-right">
            <b-dropdown
              position="is-bottom-left"
              aria-role="list">
              <a
                class="navbar-item"
                slot="trigger"
                role="button">
                <b-icon custom-class="icon-color" icon="dots-vertical"></b-icon>
              </a>
              <b-dropdown-item aria-role="listitem" @click="modifierContact(contact)">
                {{$t('creerClient.modifierContact')}}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="column card-contact" v-if="!getContacts.length">
      <div class="media media-align-center">
        <div class="media-content">
          <div class="content has-text-centered is-size-7">
            {{$t('creerClient.aucunContact')}}
          </div>
        </div>
      </div>
    </div>
    <!-- Creation d'un contact -->
    <Contact v-if="ajoutContactActive" @close="ajoutContactActive = false" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Contact from '@/components/client/contact.vue';
import * as typesContact from '@/store/modules/contacts-mutation-type';

const Contacts = createNamespacedHelpers('contacts');

export default {
  components: {
    Contact,
  },
  data () {
    return {
      ajoutContactActive: false,
    };
  },
  computed: {
    ...Contacts.mapGetters({
      getContacts: 'contacts',
    }),
  },
  methods: {
    ...Contacts.mapMutations({
      setContact: typesContact.SET_CONTACT,
    }),
    modifierContact(contact) {
      this.setContact(contact);
      this.ajoutContactActive = true;
    },
  }
}
</script>
